﻿import { SearchService } from 'travco-services';
import { pendingTask, begin, end } from 'react-redux-spinner';

let responseActions = {
    clearSearchResponse: function(response) {
        return {
            type: 'CLEAR_SEARCH_RESPONSE',
            response: ''
        };
    },
    startHotelAvailabilityResponse: function() {
        return {
            type: 'GET_HOTEL_AVAILABILITY_BEGIN',
            response: '',
            [pendingTask]: begin
        };
    },
    completeHotelAvailabilityResponse: function(response) {
        return {
            type: 'GET_HOTEL_AVAILABILITY_END',
            response: response,
            [pendingTask]: end
        };
    },
    getHotelAvailabilityXmlResponse: function(xmlRequest) {
        return (dispatch, getState) => {
            dispatch(responseActions.startHotelAvailabilityResponse());
            let service = new SearchService(getState().oidc.user !== null ? getState().oidc.user.id_token : '');
            service
                .getHotelAvailabilityXmlResponse(xmlRequest)
                .then((response) => {
                    return response.text();
                })
                .then((data) => {
                    dispatch(responseActions.completeHotelAvailabilityResponse(data));
                })
                .catch((error) => {
                    dispatch(responseActions.completeHotelAvailabilityResponse(''));
                    throw error;
                });
        };
    },
    getHotelAvailabilityJsonResponse: function(xmlRequest) {
        return (dispatch, getState) => {
            dispatch(responseActions.startHotelAvailabilityResponse());
            let service = new SearchService(getState().oidc.user !== null ? getState().oidc.user.id_token : '');
            service
                .getHotelAvailabilityJsonResponse(xmlRequest)
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    dispatch(responseActions.completeHotelAvailabilityResponse(JSON.stringify(data)));
                })
                .catch((error) => {
                    dispatch(responseActions.completeHotelAvailabilityResponse(''));
                    throw error;
                });
        };
    },
    startAllocationEnquiriesResponse: function() {
        return {
            type: 'GET_ALLOCATION_ENQUIRIES_BEGIN',
            response: '',
            [pendingTask]: begin
        };
    },
    completeAllocationEnquiriesResponse: function(response) {
        return {
            type: 'GET_ALLOCATION_ENQUIRIES_END',
            response: response,
            [pendingTask]: end
        };
    },
    getAllocationEnquiriesXmlResponse: function(xmlRequest) {
        return (dispatch, getState) => {
            dispatch(responseActions.startAllocationEnquiriesResponse());
            let service = new SearchService(getState().oidc.user !== null ? getState().oidc.user.id_token : '');
            service
                .getAllocationEnquiriesXmlResponse(xmlRequest)
                .then((response) => {
                    return response.text();
                })
                .then((data) => {
                    dispatch(responseActions.completeAllocationEnquiriesResponse(data));
                })
                .catch((error) => {
                    dispatch(responseActions.completeAllocationEnquiriesResponse(''));
                    throw error;
                });
        };
    },
    getAllocationEnquiriesJsonResponse: function(xmlRequest) {
        return (dispatch, getState) => {
            dispatch(responseActions.startAllocationEnquiriesResponse());
            let service = new SearchService(getState().oidc.user !== null ? getState().oidc.user.id_token : '');
            service
                .getAllocationEnquiriesJsonResponse(xmlRequest)
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    dispatch(responseActions.completeAllocationEnquiriesResponse(JSON.stringify(data)));
                })
                .catch((error) => {
                    dispatch(responseActions.completeAllocationEnquiriesResponse(''));
                    throw error;
                });
        };
    }
};

export default responseActions;
